export const formatDate = (value?: string) => {
  if (!value) return "-";

  const parts = value.split(" ");
  if (parts.length < 2) {
    return value;
  }

  const time = parts[parts.length - 1];
  if (!time || !time.includes(":")) {
    return value;
  }

  const [hours, minutes] = time.split(":");
  if (!hours || !minutes) {
    return value;
  }

  const hour12 = Number(hours) % 12 || 12;
  const ampm = Number(hours) >= 12 ? "PM" : "AM";

  const dateLabel = parts.length >= 3 ? `${parts[0]}, ${parts[1]}` : parts[0];
  return `${dateLabel} ${hour12.toString().padStart(2, "0")}:${minutes} ${ampm}`;
};

export const formattedDateMonth = (input: string) => {
  const date = new Date(input);
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
  });
}

export const formatToMMDD = (value?: string) => {
  if (!value) return "-";

  // Expecting YYYY-MM-DD from BE LocalDate
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return "-";

  return `${month}/${day}`;
};
